// Appels HTTP typés vers /api/intervenants/*.

import { api } from "./client";
import type {
  IntervenantCreate,
  IntervenantPublic,
  IntervenantUpdate,
  UUID,
} from "./types";

export type ListIntervenantsParams = {
  active_only?: boolean;
  limit?: number;
  offset?: number;
};

function buildQuery(params: Record<string, unknown>): string {
  const parts: string[] = [];
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === "") continue;
    parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
  }
  return parts.length ? `?${parts.join("&")}` : "";
}

export const intervenantsApi = {
  list: (params: ListIntervenantsParams = {}) =>
    api.get<IntervenantPublic[]>(`/api/intervenants${buildQuery(params)}`),

  get: (id: UUID) => api.get<IntervenantPublic>(`/api/intervenants/${id}`),

  create: (payload: IntervenantCreate) =>
    api.post<IntervenantPublic>("/api/intervenants", payload),

  update: (id: UUID, payload: IntervenantUpdate) =>
    api.patch<IntervenantPublic>(`/api/intervenants/${id}`, payload),

  delete: (id: UUID) => api.delete<void>(`/api/intervenants/${id}`),
};
